import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import {
  COPILOT_WORKFLOWS,
  SAVI_ASSISTANT_BASENAME,
  SAVI_ASSISTANT_CHAT,
} from '../constants';

export interface NavigateToDetailsProps {
  key: string;
  params?: Record<string, string>;
}

const useSaviNavigator = () => {
  const history = useHistory();

  const initiateChat = useCallback(
    (query: string): void => {
      history.push(`${SAVI_ASSISTANT_CHAT}?q=${query}`);
    },
    [history]
  );

  const initiateWorkflow = useCallback(
    (t: string) => {
      const isValidWorkFlow = Object.values(COPILOT_WORKFLOWS)
        .map((w) => w.key)
        .includes(t);

      if (isValidWorkFlow) {
        history.push(`${SAVI_ASSISTANT_CHAT}?t=${t}`);

        return;
      }

      history.push(`${SAVI_ASSISTANT_CHAT}?q=`);
    },
    [history]
  );

  const goHome = useCallback((): void => {
    history.push(SAVI_ASSISTANT_BASENAME);
  }, [history]);

  const goBack = useCallback((): void => {
    history.goBack();
  }, [history]);

  return { initiateChat, initiateWorkflow, goBack, goHome };
};

// eslint-disable-next-line import/prefer-default-export
export { useSaviNavigator };
